<template>
	<div class="email-preview-content">
		<div class="raw-test">
			<html id="target-table">
				<head>
					<meta name="viewport" content="width=device-width" />
					<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
					<meta name="description" :content="this.$store.state.page.currentTemplate.seo_description ? this.$store.state.page.currentTemplate.seo_description : 'description'">
					<meta name="Keywords" :content="this.$store.state.page.currentTemplate.seo_keywords ? this.$store.state.page.currentTemplate.seo_keywords : 'keywords'">
					<title> {{ this.$store.state.page.currentTemplate.seo_title ? this.$store.state.page.currentTemplate.seo_title : 'Test Page' }}</title>

					<v-script>
						{{ $store.state.page.customCode.head_js }}
					</v-script>

					<v-style>
						{{ $store.state.page.customCode.css }}
					</v-style>
				</head>
				<body>
					<!-- <style :v-html="$store.state.customCode.css"></style> -->
					<div class="main_wrapper_main" :class="[view+'_grid']" :style="pageStyle">
						<!-- MAIN WRAPPER -->
						<main style="width: 100%; display: flex; flex-direction: column; align-items: center; min-height: 100vh; text-decoration: inherit;">
							<!-- SECTIONS -->
							<section class="render_section_block" v-for='section in editor.content' :key='section.id' :style="[sectionStyle(section.id)]" :class="[section.advanced ? section.advanced.cssClasses : '', responsiveClasses(section.id)]" :id="section.id">
								<!-- ROWS -->
								<div class="section_row" v-for="row in section.children" :style="sectionStyle(row)" :class="[row.advanced ? row.advanced.cssClasses : '', responsiveClasses(row)]" :id="row.advanced ? row.advanced.cssId : ''">
									<!-- COLS -->
									<div class="render_section_col" v-for="col in page_findOne(row).cols" :style="'width: '+col.width + '%; padding: 15px; display:inline-block;min-width: 240px;vertical-align:top;text-decoration: inherit;'">
										<!-- CHILDREN -->
										<div v-for="item in col.children" style="display: flex; align-items: center; justify-content: center; text-decoration: inherit; min-height: 30px;">
											<component :is="'email-'+page_findChild(item).type" :details="page_findChild(item)"></component>
										</div>
										<!-- CHILDREN END -->
									</div>
									<!-- COLS END -->
								</div>
							</section>
						</main>
					</div>

					<v-script>
						{{ $store.state.page.customCode.body_js }}
					</v-script>
				</body>
			</html>
		</div>
	</div>
</template>

<script>
import {mapGetters} from 'vuex';
import spacer from "@/modules/page-editor/src/components/generator/Spacer.vue";
import button from "@/modules/page-editor/src/components/generator/Button.vue";
import headline from "@/modules/page-editor/src/components/generator/Headline.vue";
import paragraph from "@/modules/page-editor/src/components/generator/Paragraph.vue";
import image from "@/modules/page-editor/src/components/generator/Image.vue";
import video from "@/modules/page-editor/src/components/generator/Video.vue";
import link from "@/modules/page-editor/src/components/generator/Link.vue";
import social from "@/modules/page-editor/src/components/generator/Social.vue";
import menu from "@/modules/page-editor/src/components/generator/Menu.vue";
import timer from "@/modules/page-editor/src/components/generator/Timer.vue";
import custom from "@/modules/page-editor/src/components/generator/Custom.vue";
import progressBar from "@/modules/page-editor/src/components/generator/ProgressBar.vue";
import productList from "@/modules/page-editor/src/components/generator/ProductList.vue";
import formElement from "@/modules/page-editor/src/components/generator/FormElement.vue";
import paymentForm from "@/modules/page-editor/src/components/generator/PaymentForm.vue";
import twoStepForm from "@/modules/page-editor/src/components/generator/TwoStepForm.vue";
import orderSummary from "@/modules/page-editor/src/components/generator/OrderSummary.vue";
import orderBump from "@/modules/page-editor/src/components/generator/OrderBump.vue";

export default {
	name: 'PreviewEmail',
    components: {
        emailSpacer: spacer,
        emailButton: button,
        emailHeadline: headline,
        emailParagraph: paragraph,
        emailImage: image,
        emailVideo: video,
        emailLink: link,
        emailSocial: social,
        emailMenu: menu,
        emailTimer: timer,
		emailCustom: custom,
		emailProgressBar: progressBar,
		emailProductList: productList,
		emailFormElement: formElement,
		emailPaymentForm: paymentForm,
		emailTwoStepForm: twoStepForm,
		emailOrderSummary: orderSummary,
		emailOrderBump: orderBump,
	},
	data() {
		return {
			rawCode: 'raw',
			editorCore: null
		}
	},
    computed: {
		...mapGetters(['page_findOne', 'page_findChild']),
        editor() {
            return this.$store.state.page.editor
		},
		view() {
            return this.$store.state.page.view
        },
		// content() {
        //     return this.findOne(this.id);
        // },
        // basic() {
        //     return this.content.attributes.basic
		// },
		page() {
            return this.$store.state.page.page
		},
		textDecorationPage(){
            var fontStyling = this.page.basic.font ? this.page.basic.font.fontStyling : false;
            if(fontStyling['line-through'] && fontStyling.underline) {
                return 'underline line-through';
            } else if(fontStyling['line-through']) {
                return 'line-through';
            } else if(fontStyling.underline){
                return 'underline';
            } else {
                return 'inherit';
            }
        },
		pageStyle() {
            var basic = this.page.basic;
            var border = basic.border;
            var borderTop,
                borderLeft,
                borderRight,
                borderBottom;

            if (border) {
                borderTop = !border.sides.top ? 'none' : border.width + 'px ' + border.style + ' ' + border.color;
                borderLeft = !border.sides.left ? 'none' : border.width + 'px ' + border.style + ' ' + border.color;
                borderRight = !border.sides.right ? 'none' : border.width + 'px ' + border.style + ' ' + border.color;
                borderBottom = !border.sides.bottom ? 'none' : border.width + 'px ' + border.style + ' ' + border.color;
            }

            var borderRadius = border ?
                border.radius.analytics+'px '+
                border.radius.topRight+'px '+
                border.radius.bottomRight+'px '+
                border.radius.bottomLeft+'px' : false;

            var padding = basic.padding ?
                basic.padding.top+'px '+
                basic.padding.right+'px '+
                basic.padding.bottom+'px '+
                basic.padding.left+'px' : false;

            var fontFamily = basic.font ? basic.font.fontFamily : 'Roboto';
            var fontSize = basic.font ? basic.font.fontSize : '14';
            // var textAlign = this.basic.font ? this.basic.font.textAlign : 'center';
            var fontStyling = basic.font ? basic.font.fontStyling : false;
            var color = basic.font ? basic.font.color : 'initial';

			var imageUrl = basic.bgImage;
            imageUrl = imageUrl.replace('http://', '');
            imageUrl = imageUrl.replace('https://', '');
            imageUrl = imageUrl.replace(/ /g, '%20');

            var style = {
                backgroundColor: basic.bgColor,
				backgroundImage: imageUrl.length ? 'url("//'+imageUrl+'")' : 'none',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                padding,
                borderRadius,
                borderTop,
                borderLeft,
                borderRight,
                borderBottom,
                color,
                fontFamily,
                fontSize: fontSize + 'px',
                fontStyling,
                fontWeight: fontStyling.bold ? 'bold' : 'normal',
                fontStyle: fontStyling.italic ? 'italic' : 'normal',
                textDecoration: this.textDecorationPage,
            }

            return style
        },
    },
    created() {
		// console.log('Preview: ', this.editor);
		// console.log('Preview page: ', this.page);
		// console.log('this.$store.state.page.customCode: ', this.$store.state.page.customCode);
		// console.log('this.$store.state.page: ', this.$store.state.page);
	},
	mounted() {
		this.editorCore = new editorCore('Fire');
		this.editorCore.init();
	},
	beforeDestroy() {
		this.editorCore.stop();
		this.editorCore = null;
	},
	methods: {
		blockResponsive(blockId) {
            return this.page_findOne(blockId).responsive
        },
        responsiveClasses(blockId) {
            let c = '';
            if (!this.blockResponsive(blockId)) return '';
            if (!this.blockResponsive(blockId).desktop) c = 'no-desktop';
            if (!this.blockResponsive(blockId).mobile) c += ' no-mobile';
            if (!this.blockResponsive(blockId).tablets) c += ' no-tablet';
            return c;
        },
		sectionWidth(sectionId) {
			let findSection = this.page_findOne(sectionId);

			let basic = findSection.attributes.basic;

			let widthData = basic.width;

            if(widthData == 'full') {
                return '100%';
            } else if(widthData == 'wide') {
                return '75%';
            } else if(widthData == 'half') {
                return '50%';
            } else {
                return '100%'
            }
		},
		sectionMargin(sectionId){
			let findSection = this.page_findOne(sectionId);

			let basic = findSection.attributes.basic;
			var margin = basic.margin ?
				basic.margin.top+'px '+
				basic.margin.right+'px '+
				basic.margin.bottom+'px '+
				basic.margin.left+'px' : false;
			var obj = {
				margin,
			};
			return obj
		},
		textDecoration(sectionId){
			let findSection = this.page_findOne(sectionId);
			let basic = findSection.attributes.basic;
            var fontStyling = basic.font ? basic.font.fontStyling : false;
            if(fontStyling['line-through'] && fontStyling.underline) {
                return 'underline line-through';
            } else if(fontStyling['line-through']) {
                return 'line-through';
            } else if(fontStyling.underline){
                return 'underline';
            } else {
                return 'inherit';
            }
        },
		sectionStyle(sectionId) {
			let findSection = this.page_findOne(sectionId);

			let basic = findSection.attributes.basic;
			let advanced = findSection.attributes.advanced;

			var border = basic.border;
			var borderTop = border && !border.sides.top ? 'none' : false;
			var borderLeft = border && !border.sides.left ? 'none' : false;
			var borderRight = border && !border.sides.right ? 'none' : false;
			var borderBottom = border && !border.sides.bottom ? 'none' : false;

			var borderRadius = border ?
				border.radius.analytics+'px '+
				border.radius.topRight+'px '+
				border.radius.bottomRight+'px '+
				border.radius.bottomLeft+'px' : false;

			var margin = basic.margin ?
				basic.margin.top+'px '+
				basic.margin.right+'px '+
				basic.margin.bottom+'px '+
				basic.margin.left+'px' : false;

			var padding = basic.padding ?
				basic.padding.top+'px '+
				basic.padding.right+'px '+
				basic.padding.bottom+'px '+
				basic.padding.left+'px' : false;

            var fontFamily = basic.font ? basic.font.fontFamily : 'inherit';
            var fontSize = basic.font ? basic.font.fontSize + 'px' : 'inherit';
            var textAlign = basic.font ? basic.font.textAlign : 'center';
            var fontStyling = basic.font ? basic.font.fontStyling : false;
            var color = basic.font ? basic.font.color : 'inherit';

            var boxShadow = advanced.shadows ?
                advanced.shadows.color+ ' ' +
                advanced.shadows.angle+'px '+
                advanced.shadows.distance+'px '+
                advanced.shadows.blur+'px '+
                advanced.shadows.spread+'px '+
                advanced.shadows.type : false;

			var maxWidth = this.sectionWidth(sectionId);

			//  var imageUrl = basic.backgroundImage ? basic.backgroundImage : 'none';
            // imageUrl = imageUrl.replace('http://', '');
            // imageUrl = imageUrl.replace('https://', '');
            // imageUrl = imageUrl.replace(/ /g, '%20');

			var obj = {
				// borderColor: this.label.bg,
				backgroundColor: basic.backgroundColor || 'transparent',
				backgroundImage: basic.backgroundImage ? `url("//${basic.backgroundImage}")` : 'none',
				backgroundPosition: 'center',
				backgroundSize: 'cover',
				backgroundRepeat: 'no-repeat',
				// margin,
				padding,
				borderWidth: border ? basic.border.width + 'px' : 'initial',
				borderColor:  border ? basic.border.color : 'initial',
				borderStyle:  border ? basic.border.style : 'initial',
				borderRadius,
				borderTop,
				borderLeft,
				borderRight,
				borderBottom,
				maxWidth,
				width: '100%',
                color,
                fontFamily,
                fontSize,
                textAlign,
                fontStyling,
                fontWeight: fontStyling.bold ? 'bold' : 'inherit',
                fontStyle: fontStyling.italic ? 'italic' : 'inherit',
                textDecoration: this.textDecoration(sectionId),
                boxShadow,
			};
			return obj
		}
	}
}
</script>

<style>
    .raw-test {
        height: 100vh;
        overflow: auto;
    }
	.back-to-editor {
		position: fixed;
		top: 85px;
		right: 85px;
		left: auto;
	}
	.raw-code {
		display: block;
		width: 100%;
		padding: 50px;
		background: #000;
		color: #fff;
	}
</style>
